import { render, staticRenderFns } from "./CardCounter.vue?vue&type=template&id=47d9897c&scoped=true&"
import script from "./CardCounter.vue?vue&type=script&lang=js&"
export * from "./CardCounter.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/furnitures.scss?vue&type=style&index=0&id=47d9897c&lang=scss&scoped=true&"
import style1 from "./CardCounter.vue?vue&type=style&index=1&id=47d9897c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d9897c",
  null
  
)

export default component.exports